<template>
  <v-container fluid>
		<v-data-table
			v-show="!editIncludes"
			:headers="headers"
			:search="search"
			item-key="id"
			:loading="$store.state.companies.loadingCompaniesProjectTypes"
			loading-text="Cargando datos..."
			:footer-props="{
				itemsPerPageText: 'Filas por página'
			}"
			:items-per-page="-1"
			hide-default-footer
		>
			<template v-slot:body>
				<tbody v-for="category in $store.state.companies.companiesProjectTypesCategories" :key="'pt_'+category.id">
					<tr class="grey lighten-2">
						<td class="py-0" style="height: 30px;">
							<p class="mb-0 caption font-weight-bold mr-2">{{ category.name }}</p>
						</td>
						<td class="py-0" style="height: 30px;">
							<div class="d-flex align-center justify-center">
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="warning"
											class="mx-1"
											v-if="$checkPermissions(['delete_company_project_types']) && category.company_id"
											@click.stop="editCompanyProjectType(category)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-pencil-outline</v-icon>
										</v-btn>
									</template>
									<span>Editar</span>
								</v-tooltip>
								<v-tooltip bottom>
									<template v-slot:activator="{ on, attrs }">
										<v-btn
											icon
											dark
											x-small
											color="error"
											class="mx-1"
											v-if="$checkPermissions(['delete_company_project_types']) && category.company_id"
											@click.stop="deleteCompanyProjectType(category.id)"
											v-bind="attrs"
											v-on="on"
										>
											<v-icon small dark>mdi-delete-outline</v-icon>
										</v-btn>
									</template>
									<span>Eliminar</span>
								</v-tooltip>
							</div>
						</td>
						<td colspan="2" class="py-0" style="height: 30px;"></td>
					</tr>
					<tr
						v-for="item in category.project_types"
						:key="item.id"
						style="cursor: pointer;"
						:class="selectedRowClass(item)"
						@click="selectRow(item)"
					>
						<td style="cursor: pointer;">
							<div class="ml-3">
								<p class="caption mb-0 font-weight-bold">[{{ item.code }}] {{ item.name }}</p>
								<p class="caption mb-0">{{ item.description }}</p>
							</div>
						</td>
						<td style="cursor: pointer;width: 140px;">
							<div class="d-flex justify-center fill-height">
								<v-checkbox
									v-model="item.show_in_client"
									color="black"
									hide-details
									dense
									@change="onChangeItemShowClient(item)"></v-checkbox>
							</div>
						</td>
						<td style="cursor: pointer;">
							<div>
								<div class="text-center" v-if="!item.sub_types.length && item.show_in_client">
									<p class="mb-0" style="font-size: 10px;">Para que aparezca en el listado del cliente debes agregar al menos 1 sub elemento.</p>
									<v-btn icon small @click="addingSubitem = item.id" v-if="addingSubitem != item.id">
										<v-icon>mdi-plus</v-icon>
									</v-btn>
								</div>
								<div class="text-center" v-else>
									<div>
										<v-chip
											v-for="sub_type in item.sub_types"
											:key="sub_type.id"
											:close="!!sub_type.company_id"
											x-small
											@click:close="deleteProjectType(sub_type.id)"
										>
											{{ sub_type.name }}
										</v-chip>
									</div>
									<v-btn icon small @click="addingSubitem = item.id" v-if="addingSubitem != item.id">
										<v-icon>mdi-plus</v-icon>
									</v-btn>
								</div>
							</div>
							<v-divider class="my-2" v-if="addingSubitem == item.id"></v-divider>
							<div class="mb-2" v-if="addingSubitem == item.id">
								<v-text-field
									v-model="newSubTypeName"
									label="Nombre del Sub Tipo"
									outlined
									required
									dense
									hide-details=""
									maxlength="255"
									class="custom-height-search custom-height-calendar"
									@keyup.enter="sendNewSubType"
								>
									<template v-slot:append-outer>
										<v-btn
											icon
											x-small
											color="error"
											@click.stop="() => { selectRow(item); cancelAddingSubItem(); }"
										>
											<v-icon>mdi-close</v-icon>
										</v-btn>
										<v-btn
											icon
											x-small
											color="green"
											@click.stop="() => { selectRow(item); sendNewSubType(); }"
										>
											<v-icon>mdi-check</v-icon>
										</v-btn>
									</template>
								</v-text-field>
								<!-- <div class="d-flex align-center">
									<v-checkbox
										v-model="newSubTypeType"
										dense
										hide-details
										color="black"
										class="caption my-0 py-0 custom-checkbox">
										<template v-slot:label>
											<p class="mb-0 font-weight-bold" style="font-size: 10px;">Es un Proyecto Directo Para Recepción Final</p>	
										</template>
									</v-checkbox>
								</div> -->
							</div>
						</td>
						<td>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="green"
										class="mx-1"
										v-if="$checkPermissions(['edit_company_project_types'])"
										@click.stop="$router.push({ name: 'ProjectTypesStages' })"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-order-bool-ascending-variant</v-icon>
									</v-btn>
								</template>
								<span>Modificar Etapas Incluidas</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="warning"
										class="mx-1"
										v-if="$checkPermissions(['delete_company_project_types']) && item.company_id"
										@click.stop="() => { selectRow(item); editProjectType(item); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-pencil-outline</v-icon>
									</v-btn>
								</template>
								<span>Editar</span>
							</v-tooltip>
							<v-tooltip bottom>
								<template v-slot:activator="{ on, attrs }">
									<v-btn
										icon
										dark
										x-small
										color="error"
										class="mx-1"
										v-if="$checkPermissions(['delete_company_project_types']) && item.company_id"
										@click.stop="() => { selectRow(item); deleteProjectType(item.id); }"
										v-bind="attrs"
										v-on="on"
									>
										<v-icon small dark>mdi-delete-outline</v-icon>
									</v-btn>
								</template>
								<span>Eliminar</span>
							</v-tooltip>
						</td>
					</tr>
				</tbody>
			</template>
		</v-data-table>
  </v-container>
</template>

<script>
import {deleteProjectType, updateProjectTypeOrders, createProjectType, updateProjectType, deleteCompanyProjectTypeCategory} from '@/helpers/api/company'
import _debounce from 'lodash/debounce'

export default {
  components: {
  },
  data() {
    return {
      search: '',
			editIncludes: false,
			selectedRowItem: null,
			addingSubitem: null,
			newSubTypeName: null,
			newSubTypeType: false,
      debouncedUpdates: {},
      headers: [
        { text: 'Tipo de Proyecto', value: 'name', sortable: false },
        { text: 'Mostrar a Clientes', value: 'show_in_client', width: 140, align: 'center', sortable: false },
        { text: 'Sub Tipos', value: 'sub_elements', sortable: false },
        { text: 'Acciones', value: 'actions', width: 120, sortable: false },
      ],
    };
  },
  computed: {
		companyPlanningStages(){
			return this.$store.state.companies.companyPlanningStages
		},
		selectedCompany(){
			return this.$store.state.companies.selectedCompany
		}
  },
	watch: {
		selectedCompany(newValue){
			if(newValue){
				this.reloadInfo()
			}
		}
	},
	mounted(){
		if(this.selectedCompany){
			this.reloadInfo()
		}
		const selectedRow = JSON.parse(localStorage.getItem('selected_prjecttypeslist_row'));
		if (selectedRow) {
			this.selectedRowItem = selectedRow
		}
	},
  methods: {
		selectRow(item){
			this.selectedRowItem = item.id
			localStorage.setItem('selected_prjecttypeslist_row', JSON.stringify(item.id))
		},
		selectedRowClass(item){
			if (this.selectedRowItem && this.selectedRowItem === item.id) {
				return 'selected-row-custom-item';
			}
			return ''
		},
		reloadInfoDebounced: _debounce(function(){ this.reloadInfo() }, 1000),
		reloadInfo(){
			this.$store.dispatch('companies/getCompanyProjectTypes')
		},
		onChangeItemShowClient(item){
			this.updateProjectTypeInfo(item)
		},
		async updateProjectTypeInfo(item){
			const data = {
				...{project_type_id: item.id},
				...item
			}
			await updateProjectType(data)
			this.reloadInfoDebounced()
		},
		startEndDragEvent: _debounce(function(ev){ this.endDragEvent(ev) }, 800),
		async endDragEvent(ev){
			if (typeof ev.newIndex === 'number') {
				const project_types = this.$store.state.companies.companiesProjectTypes.map((project_type, index) => {
					return { order: index + 1, id: project_type.id}
				})
				await updateProjectTypeOrders({project_types})
				this.reloadInfo()
			}
		},
		async sendNewSubType(){
      const data = {
				name: this.newSubTypeName,
				parent_id: this.addingSubitem,
				type: this.newSubTypeType ? 2:1,
				code: '--'
			}
			this.cancelAddingSubItem()
			await createProjectType(data)
			this.reloadInfo()
		},
		cancelAddingSubItem(){
			this.addingSubitem = null
			this.newSubTypeName = null
		},
    addProjectType() {
			this.$store.commit('companies/setNewProjectTypeModalEditing', null)
			this.$store.commit('companies/setNewProjectTypeModal', true)
    },
    editProjectType(project_type) {
			const data = {
				project_type_id: project_type.id,
				name: project_type.name,
				description: project_type.description,
				code: project_type.code
			}
			this.$store.commit('companies/setNewProjectTypeModalEditing', data)
			this.$store.commit('companies/setNewProjectTypeModal', true)
    },
    async deleteProjectType(project_type_id) {
      await deleteProjectType({project_type_id})
			this.reloadInfo()
    },
    editCompanyProjectType(category) {
			const data = {
				category_id: category.id,
				name: category.name,
				description: category.description
			}
			this.$store.commit('companies/setNewCategoryProjectTypeModalEditing', data)
			this.$store.commit('companies/setNewCategoryProjectTypeModal', true)
    },
    async deleteCompanyProjectType(category_id) {
      await deleteCompanyProjectTypeCategory({category_id})
			this.reloadInfo()
    }
  },
};
</script>

<style>
.custom-checkbox .v-input--selection-controls__input{
	margin-right: 0;
}
</style>